import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../../shared/services/apiService.service'
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';
import { environment } from '../../../environments/environment';
import { debounce } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { SkeletonService } from '../../shared/services/skeleton.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { RootService } from 'src/app/shared/services/root.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { FormErrorService } from 'src/app/shared/form-validation/form-error.service';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { CanonicalService } from 'src/app/shared/seo/canonical.service';

@Component({
  selector: 'app-tataokplplist',
  templateUrl: './tataokplplist.component.html',
  styleUrls: ['./tataokplplist.component.scss']
})
export class TataokplplistComponent implements OnInit,OnDestroy {

  filterShowList: any = [];
  sub: Subscription = new Subscription();
  userFormplp: FormGroup;
  model: string | null = null;
  minprice: string | null = null;
  maxprice: string | null = null;
  states: string | null = null;
  filterValueTemp: any[];
  userData: any;
  showLoader: boolean =false;
  @ViewChild('myCheckbox') myCheckbox!: ElementRef;
  isUserLoggedIn: boolean = false;
  userLoginForm: FormGroup;
  isshowLogin: boolean = false;
  isshowOtp: boolean = false;
  isshowSignUp: boolean = false;
  constructor(private activatedRoute: ActivatedRoute,
    public skeletonService: SkeletonService,
    private rootService: RootService,
    private fb: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object,
    private behaviourSubject: BehaviourSubjectService,
    private apiservice: ApiService,
    private router:Router,
    private regexService: RegexService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private formErrorService: FormErrorService,
    private localStorage: secureStorage,private canonicalservice: CanonicalService) {
    this.onScroll = debounce(this.onScroll, 300);
  }
  checkBoxControl = new FormControl(false);
  environment1 = environment.s3bucket.url;
  productLoaded: boolean = false;

  isFilterOpen: boolean = false;
  isBottomhide: boolean = true;
  checkBoxcheked:boolean=false;
  disableForm:boolean=false;
  ListingData = [];
 ModelFilterArray: any = [];
 CitiesFilterArray: any = [];

 StateFilterArray: any = [];

offset: number = 0;
data: any = {
  "data": [
    {
      "key": "District",
      "priority": "3",
      "isvisible": "1"
    },
    {
      "key": "Models",
      "priority": "0",
      "isvisible": "1"
    },

    {
      "key": "State",
      "priority": "2",
      "isvisible": "1"
    },
    {
      "key": "Budget",
      "priority": "1",
      "isvisible": "1"
    }
  ]
}

  sortingType: string = 'Select'
  price_From: any;
  price_To: any;
  sortList = ["Select", "High To Low", "Low To High"]

  @ViewChild('myImodelClosebtnnput') modelClosebtn!: ElementRef;
  VehicleId:any;
  errorMessage:any;
  filterList: any = [];
  filtersFromPrevious:any;
TotalCount:any;
order_by=''
CatId:any;
utm_source: any;
utm_medium: any;
utm_campaign: any;
gclid: any;
campaign_id:any;
dealercode: string;
  dealerLen: any = [];
  ngOnInit(): void {
          const url = this.router.url;
          const trimmedUrl = url.startsWith('/') ? url.substring(1) : url;
        
          this.canonicalservice.createCanonicalURL(trimmedUrl);
    this.route.params.subscribe((params) => {
      const data = params['catId'];
      this.CatId=params['id']
    });
    this.sub.add(
      this.behaviourSubject.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
        this.userData = this.rootService.getUserData();
      })
    );
    this.sub.add(
      this.behaviourSubject.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
        this.userData = this.rootService.getUserData();
          if(this.isUserLoggedIn){
            this.closeModel()
          }
      })
    );
    this.sub.add(this.behaviourSubject.isTataOkLogin.subscribe((ele)=>{
      let data = {
        name:this.userData.first_name + ' ' + this.userData.last_name,
        contact:this.userData.mobile_number
      }
     if(ele && this.VehicleId){
      // if(window.location.href(''))
      this.createLead(data);
     }
    }));
    this.route.queryParamMap.subscribe((params) => {
      // this.model = params.get('model');
      // this.minprice = params.get('minprice');
      // this.maxprice = params.get('maxprice');
      // this.city = params.get('city');
    });
    if (isPlatformBrowser(this.platformId)) {
    this.filtersFromPrevious= JSON.parse(localStorage.getItem('tataOkFilters') || '{}');
    }
    this.model = this.filtersFromPrevious.model || '';
    this.minprice = this.filtersFromPrevious.minprice || '';
    this.maxprice = this.filtersFromPrevious.maxprice || '';
    this.states = this.filtersFromPrevious.states || '';

    this.filterValueTemp=	[];
    if (this.model) {
      this.filterValueTemp.push({"event":this.model,"category":"Models"})
    }
    if (this.states) {
      this.filterValueTemp.push({"event":this.states,"category":"State"})
    }
    if (this.minprice || this.maxprice) {
      this.filterValueTemp.push({"event":this.minprice ? this.minprice : 0,"category":"price_from"})
      this.filterValueTemp.push({"event":this.maxprice,"category":"price_to"})
    }
if (isPlatformBrowser(this.platformId)) {
   if (this.filterValueTemp?.length>0) {
    localStorage.setItem("normalFilterValue", JSON.stringify(this.filterValueTemp))
   }
   this.dealercode = localStorage.getItem('dealercd');

    var Json = {
      minValue:this.minprice,
      maxValue:this.maxprice ? this.maxprice : localStorage.getItem('max_price')
    }
    this.behaviourSubject.budgetFiltertataok.next(Json)
  }
    this.sub.add(this.behaviourSubject.filterValue.subscribe(params => {
      if (params != true && params != false) {
        for (let j = 0; j < this.data[this.filterList]?.length; j++) {
          for (let i = 0; i < this.data[this.filterList][j]?.data?.length; i++) {
            if (params == this.data[this.filterList][j].data[i].key) {
              this.data[this.filterList][j].data[i].checked = false;
            }
          }
        }

          setTimeout(() => {
            if (params != 'Header') {
              this.getFilterList();
              this.getListingdata(0);
            }
            else {
              if (isPlatformBrowser(this.platformId)) {

                localStorage.removeItem('normalFilterValue');
              }
            }
          }, 100);
      }
    }))
    this.sub.add(this.behaviourSubject.isMobileFilter.subscribe(isClosed => {
      if (isClosed == 'Close') {
        this.isFilterOpen = false;
        this.isBottomhide = true
      }
    }))
    this.userform();
    this.getFilterList();
    this.getListingdata(0);
    this.getUserdata()
    this.campaign();
    this.setLoginHome();
       this.sub.add(this.activatedRoute.queryParams.subscribe((params) => {
      if (params['dealer']) {
        if (isPlatformBrowser(this.platformId)) {

          localStorage.setItem("dealercd", params['dealer']);
        }
          this.getDealer()
        
      }
    }));
  }
  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (isPlatformBrowser(this.platformId)) {
    if ((window.innerHeight + window.scrollY+750) >= document.body.offsetHeight) {
      if (this.TotalCount != null && this.TotalCount != '' && this.TotalCount != undefined) {
        if (this.TotalCount>0 && this.ListingData?.length>0) {
      if (this.TotalCount > this.ListingData?.length) {
        this.offset += 10;
        this.getListingdata(this.offset);
      }
    }
  }
    }
  }
  }
  campaign() {
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.utm_source = await params['utm_source'];
      this.utm_medium = await params['utm_medium'];
      this.utm_campaign = await params['utm_campaign'] || await params['utm_campaignname'];
      this.gclid = await params['gclid'];
      this.campaign_id = await params['campaign_id'];
    })
  }
    getDealer() {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem("dealername")
    
    {
      let data = {
        "dealer_code": localStorage.getItem("dealercd"),
        "action_type": "dropdown"
    };
      this.sub.add(this.apiservice.getDealerList(data).subscribe({
        next: (response: any) => {
          if (response["success"]) {
            this.dealerLen = response?.data;


            localStorage.setItem("dealername", (this.dealerLen[0].division_name + '_' + this.dealerLen[0].dealer_code))
            this.behaviourSubject.dealerName.next(true)

          }
        },
        error: (error) => {
          this.toastrService.warning(error.data.msg);
        },
        complete: () => {
        }
      })
      );

    }
    }
  }
  userform(){
    this.userFormplp = this.fb.group({
      name: ['', [Validators.required]],
      contact: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      consent: ['', Validators.required]
    });
  }
  openSort() {
    if (isPlatformBrowser(this.platformId)) {
      $('.sort-mobile-view').addClass('d-block');
      $('.sort-mobile-view').removeClass('d-none');
    }
  }
  toggleFilters() {
    this.isFilterOpen = !this.isFilterOpen;
    this.isBottomhide = false
  }
  closeSort() {
    if (isPlatformBrowser(this.platformId)) {
      $('.sort-mobile-view').addClass('d-none');
    }
  }
  notAllowSpace(event: any) {
    if (event.target.selectionStart === 0 && event.which === 32) {
      event.preventDefault();
    }
  }
  onSubmit() {
    if (this.userFormplp.valid) {
      this.spinner.show()
      this.showLoader = true;
      this.createLead(this.userFormplp.value)
    } else {
      this.disableForm=false;
      this.toastrService.warning("Form is invalid")
    }
    this.checkBoxControl.setValue(false);

  }
  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }
  onCheckboxChange(checked: boolean) {
    if (checked) {
      this.checkBoxcheked=true
    } else {
      this.checkBoxcheked=false
    }
  }
  contactDealer(id:any){
    this.VehicleId=id;
    this.disableForm=false;
    this.checkBoxcheked=false
    this.checkBoxControl.setValue(false);
    this.userLoginForm.reset();
    this.setForm()
  }
  getListingdata(val:any) {
    if (val == 0) {
      this.ListingData = [];
    }
    let data = {
      cat_id : Number(this.CatId),
      offset: val,
      district:this.CitiesFilterArray?.length !==0 ? this.CitiesFilterArray:'',
    minimum_msrp: this.price_From ? String(this.price_From) :this.price_From == 0 ?  String(this.price_From): '',
    maximum_msrp:this.price_To ? String(this.price_To) :'',
    model:this.ModelFilterArray?.length !==0 ? this.ModelFilterArray :'',
    vehicle_type:"",
    state:this.StateFilterArray?.length !==0 ? this.StateFilterArray :'',
    params_approval_status:'APPROVED',
    order_by:this.order_by,
    distributor_code:this.dealercode ? this.dealercode : ''
    };
    this.spinner.show()
    try {
      this.sub.add(this.apiservice.getTataokhomedata(data).subscribe({
        next: (response) => {
          if (response.success) {
            this.spinner.hide();
            this.productLoaded=true
            if (this.ListingData?.length<10) {
              this.ListingData=[...response.data]
            }
            else{
              this.ListingData = [...this.ListingData, ...response.data];
            }
            this.TotalCount=response.total_count;
          }
          else{
            this.productLoaded=true
            this.ListingData=[]
            this.TotalCount=0
          this.spinner.hide();
          }
        },
        error: (error) => {
          this.TotalCount=0
          this.spinner.hide();
        },
      })
      )
    } catch (error) {
    }
;
  }
  generateArray() {
this.StateFilterArray=[];
this.CitiesFilterArray=[];
this.ModelFilterArray=[];
    this.price_From = ""
    this.price_To = ""
    for (let i = 0; i < this.filterList?.length; i++) {
      if (this.filterList[i].category == "State") {
        this.StateFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "District") {
        this.CitiesFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "Models") {
        this.ModelFilterArray.push(this.filterList[i].event)
      }
      else if (this.filterList[i].category == "price_from") {
        this.price_From = this.filterList[i].event
      }
      else if (this.filterList[i].category == "price_to") {
        this.price_To = this.filterList[i].event
      }

    }
  }
  onFilterChange(event: any, source: any){
    var type
    if (source == '') {
      type = event?.target?.value ? event?.target?.value : event
    }
    else {
      type = event
    }
    if (type == 'High To Low') {
      this.order_by='-dealer_suggestive_price';
      this.getListingdata(0);


    }
    else if (type == 'Low To High') {
      this.order_by='dealer_suggestive_price'
      this.getListingdata(0);
    }
    else{
      this.order_by=''
    this.getListingdata(0);

    }
    this.behaviourSubject.generatetataokfilter.next(true)
  }
  redirect(id:number){
    this.router.navigate([`/buy-used-vehicles-productdetail/${id}`])
  }

  getFilterList() {
    if (isPlatformBrowser(this.platformId)) {
        this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : [];
        this.filterShowList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : [];

      if (this.filterShowList) {
        if (this.filterShowList.find(element => element.category == "price_from") && this.filterList.find(element => element.category == "price_to")) {
          var priceFrom = this.filterShowList.find(element => element.category == "price_from")
          var priceTo = this.filterShowList.find(element => element.category == "price_to")
          var json = {
            "category": 'Budget',
            "event": "₹"+priceFrom.event + '-' + "₹"+priceTo.event
          }
          let i = this.filterShowList.findIndex(element => element.category == 'price_from')
          this.filterShowList.splice(i, 1);
          let t = this.filterShowList.findIndex(element => element.category == 'price_to')
          this.filterShowList.splice(t, 1);
          this.filterShowList.push(json)
        }
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    this.generateArray();
  }
  clickToremoveFilter(event: any) {
if (isPlatformBrowser(this.platformId)) {
    let storedFilters = JSON.parse(localStorage.getItem('tataOkFilters') || '{}');

    if (event.category === 'Models' && storedFilters.model === event.event) {
      this.filtersFromPrevious.model = '';
    }

    if (event.category === 'State' && storedFilters.states === event.event) {
      this.filtersFromPrevious.states = '';
    }

    if (event.category === 'Budget') {
      const [eventMinPrice, eventMaxPrice] = event.event.replace(/[₹,]/g, '').split('-');

      if (storedFilters.minprice === eventMinPrice) {
        this.filtersFromPrevious.minprice = '';
      }
      if (storedFilters.maxprice === eventMaxPrice) {
        this.filtersFromPrevious.maxprice = '';
      }
    }
for (let key in this.filtersFromPrevious) {
  if (this.filtersFromPrevious[key] === '') {
    delete this.filtersFromPrevious[key];
  }
}

    // localStorage.setItem('tataOkFilters', JSON.stringify(this.filtersFromPrevious));
    localStorage.setItem('tataOkFilters', JSON.stringify(this.filtersFromPrevious));
}
    if (event.category !== 'Budget') {
      this.behaviourSubject.filterValue.next(event.event);
    } else {
      this.behaviourSubject.filterValue.next(event.category);
    }
  }
  createLead(data:any){
    this.errorMessage = ''
    const nameParts = data.name.split(' ');
    const firstName = nameParts[0];
    const lastName = nameParts[1];
   let Payload={
    "first_name":firstName?firstName:'',
    "last_name": lastName?lastName:'',
    "mobile_no":data.contact,
    "vehicle_id":this.VehicleId,
    "lead_source":"osp",
    "financing":data.consent == 'yes' ? true : false,
    "address_one":this.userData.address_one,
          "address_two":this.userData.address_two,
          "city":this.userData.city,
          "district":this.userData.district,
          "pincode":this.userData.pincode,
          "state":this.userData.state,
          "taluka":this.userData.taluka,
          "utm_source":this.utm_source ? this.utm_source : '',
          "utm_medium":this.utm_medium  ? this.utm_medium : '',
         "utm_campaign":this.utm_campaign ? this.utm_campaign : '',
         "campaign_id":this.campaign_id ? this.campaign_id : '',
         "device_source":"Fleet Verse Web"
   };
   this.spinner.show()
   this.showLoader = true;
   try {
    this.sub.add( this.apiservice.getCreateLead(Payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.disableForm=true;
          this.productLoaded=true
          this.toastrService.success(response?.data?.msg || response.msg);
          this.errorMessage=response;
          this.spinner.hide();
          this.showLoader = false;
        }

        else{
          this.showLoader = false;
        this.spinner.hide();
          this.toastrService.warning(response?.data?.msg);
          if (isPlatformBrowser(this.platformId)) {
            let element =document.getElementById('closeBtn');
            element.click();
          }
        }
      },
      error: (error) => {
        this.showLoader = false;
        this.spinner.hide();
        if (isPlatformBrowser(this.platformId)) {
          let element =document.getElementById('closeBtn');
          element.click();
        }
      },
     })
    )
  } catch (error) {
  }

  }
  getLead(data:any){

   let Payload={
  "offset":data
   };
   this.spinner.show()
   try {
    this.sub.add(   this.apiservice.getTataokLead(Payload).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.productLoaded=true
      },
      error: (error) => {

      },
     })
    )
  } catch (error) {
  }

  }
  getUserdata(){
    this.sub.add(this.apiservice.getUserData().subscribe({
      next: (response: any) => {
      this.userData=response?.data;
      }
    }));
  }
  setForm(){
    if (isPlatformBrowser(this.platformId)) {
    const fullName = this.userData?.first_name + ' ' + this.userData?.last_name;
    this.userFormplp = this.fb.group({
      name: [fullName ? fullName :'', [Validators.required]],
      contact: [this.userData?.mobile_number ? this.userData?.mobile_number : '', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      consent: ['yes', Validators.required]
    });
    this.myCheckbox.nativeElement.checked = false;
    if (this.userFormplp.controls['contact'].invalid) {
      this.userFormplp.controls['contact'].markAsTouched();
    }
    if (!this.isUserLoggedIn) {
      localStorage.setItem('catIdid','true')
      this.behaviourSubject.isTataOkPLPPage.next(true)
      if(this.CatId){
        let obj= {
          url:`/buy-used-vehicles-productlist/${this.CatId}`
        }
        localStorage.setItem('previousUrl',JSON.stringify(obj))
        // this.router.navigate(['/login/']);
      }else{
        localStorage.setItem('previousUrl',this.router.url)
        // this.router.navigate(['/login/']);
      }

    }
  }
  }
  getFirstPartOfOwners(owners: string | undefined): string {
    if (!owners) {
      return '';
    }
    return owners.split(/[-\s]/)[0];
  }
  exploreProduct(){
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem('tataOkFilters')
    localStorage.removeItem('normalFilterValue')
    this.behaviourSubject.filterValue.next('Explore');
    this.behaviourSubject.tataokisClearfilter.next(true)
    this.router.navigate(['/buy-used-vehicles-productlist']);
    }
  }
  getiscover(data:any){
    if (data.length > 0) {
      const original_data = data
      const images = [...data];
      const filteredImages = images.filter(item => item.is_cover === true);
      if (filteredImages.length > 0) {
          return filteredImages[0].path
      } else {
          return original_data[0].path
      }
    }
    else{
      return '../../../assets/images/default_image.jpg'
    }

  }

  closeModel() {
    if (isPlatformBrowser(this.platformId)) {
      let element = document.getElementById('closeBtn1');
     
      if(element && this.isshowLogin){
        element.click();
      }
      let element1 = document.getElementById('closeBtn2');
      if(element1){
        element1.click();
      }
    }
  }

  setLoginHome(){
    if (isPlatformBrowser(this.platformId)) {
    this.userLoginForm = this.fb.group({
      mobile_number: [this.userData?.mobile_number ? this.userData?.mobile_number : '', [Validators.required, Validators.pattern(this.regexService.Phone)]],
    });
    }
  }

  showLogin() {
    this.isshowLogin = true;
    this.isshowOtp = false;
    this.isshowSignUp = false;
     if (isPlatformBrowser(this.platformId)) {
    if(window.location.href.includes('buy-used-vehicles-productlist')){
      let ele = document.getElementById('otpVerification')
      ele.click(); 
    }
  }
  }

  showOtp() {
    this.isshowLogin = false;
    this.isshowOtp = true;
    this.isshowSignUp = false;
  }

  showSignup(){
    this.isshowLogin = false
    this.isshowOtp = false;
    this.isshowSignUp = true;
  }

  sentOtp() {

      // if (this.isSentOTP) {
      //   return;
      // }
      // this.isSentOTP = true;
      if (this.userLoginForm.status === 'INVALID') {
        this.formErrorService.displayFormErrors(this.userLoginForm);
        return;
      }
      this.spinner.show();
      let data = {
        mobile_number: this.userLoginForm.controls['mobile_number'].value,
        action_type: 'login',
        user_source: "Tataok"
      };
      this.sub.add(
        this.apiservice.sentOtp1(data).subscribe({
          next: (response: any) => {
            // this.isSentOTP = false;
            if (response.success) {
              this.toastrService.success(response.data.msg);
              this.spinner.hide();
              if(this.checkBoxcheked && this.userLoginForm.controls['mobile_number']?.value){
                this.getConsentData(this.userLoginForm.controls['mobile_number']?.value)
              }
              if (isPlatformBrowser(this.platformId)) {
              this.localStorage.setItem("loginNumber", JSON.stringify(this.userLoginForm.controls['mobile_number'].value))
              localStorage.removeItem("signup")
              }
              this.isshowLogin = false
              this.isshowOtp = true;
              this.isshowSignUp = false;

              // this.router.navigate(['/otp/']);
              if (isPlatformBrowser(this.platformId)) {
                window.scroll(0, 0);
              }
            }
            else {
                  this.toastrService.warning('Something went wrong!');
                  this.spinner.hide();
                  this.closeModel()
                }
          },
          error: () => {
            this.toastrService.warning('Something went wrong!');
            this.spinner.hide();
            this.closeModel()
          },
          complete: () => { },
        })
      );
    
  }

  getConsentData(value) {
    if (isPlatformBrowser(this.platformId)) {
    const signup = JSON.parse(this.localStorage.getItem("signup")) ? true : false;
    let data = {
      "mobile_number": value,
      'source': signup ? 'Web Registration' : 'Web Login'
    }
    this.apiservice.get_amc_consent_view(data).subscribe((res) => {
    })
  }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.sub.unsubscribe()
    }
  }
}
